// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"342":"7913701f","434":"a7e87f6b","655":"944c0ee6","710":"6278cde4","742":"3cf63107","823":"3a9bf4bf","925":"c38521f7"}[chunkId] + ".chunk.js";
};